import {Component, OnInit, OnDestroy, HostListener} from "@angular/core";
import {interval} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {HttpErrorResponse} from "@angular/common/http";
//import '../../template/js/plugins/forms/inputs/typeahead/typeahead.bundle.min.js';

declare var $:any;
/**
 * This class represents the lazy loaded JobDetailsComponent.
 */
@Component({
    selector: 'sd-jobDetails',
    templateUrl: 'jobDetails.component.html',
    styleUrls: ['jobDetails.component.css'],
    providers: [Communication.JobsService, Communication.UsersService, Communication.EmailsService, Communication.TagsService, Communication.DocumentsService, Communication.RecipientsService, Communication.RecipientRequestService, Communication.AccesscodeService, Communication.SftpService, Communication.TeamService, Communication.AttachmentsService],
    standalone: false
})


export class JobDetailsComponent implements OnInit, OnDestroy {
  currentToolbar:any;
  page:number = 1;
  rotation:number = 0;
  zoom:number = 1.0;
  originalSize:boolean = false;
  showAll:boolean = true;
  pdf:any;
  renderText:boolean = false;

  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];

  jobIDParameter:number;
  requestCode:string='';
  theJob:Communication.Job;
    pdfSrcTMP = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfSrc:any = {
    'url': '',
    'httpHeaders': {
      'access_token': "1"
    }
  };
  resizeTimer:any;

  modalInfoVisibility:boolean=false;
  // One-shot guard so a `#info` fragment auto-opens the info modal only once per load.
  private infoFragmentHandled:boolean=false;
  attachmentsModalVisibility:boolean=false;
  validationModalVisible:boolean=false;
  validationResult:any=null;
  validationLoading:boolean=false;
  validationError:string=null;
  expandedPanels: {[key: string]: boolean} = {};
  returnUrl:string;
  recipientState:string = "";
  jobOwner:string = "";
  jobLocation:string = "";
  theJobHistory:Communication.AuditLog[];
  selectedAuditLog:Communication.AuditLog;
  selectedAuditLogDetail:string[];
  tagItems:string[] = [];
  jobNewName:string = "";
  allTagItems:string[] = [];
  availableTagItems:string[] = [];
  sharingModalVisibility:boolean = false;
  sharingDocument = {
    'id': 0,
    'name': ''
  };
  containers: Array<Container> = [];
  widgets: Array<Communication.Recipient> = [];

  theRecipient:Communication.Recipient;
  isDisabled:boolean;
  templateVisibility:boolean=false;
  templateJobs:Array<Communication.Job> = [];
  selectedTemplate:Communication.Job;
  isUserDataFetched:boolean = true;
  auditSignatures:any=[];
  pdfLoading:boolean = true;
  hasResize:boolean=false;
  previousWidth:number;
  template:any={};
  lastShapePage:number;
  stopResizeEvent:boolean=false;
  sftpDetails: Array<{
    id:number,
    serverName:string

  }> = [];
  checkedSftpServer:string;
  ownerTeamMembers: Array<{
    id:number,
    branch: String,
    memberEmail: String,
  }> = [];
  currentDepartmentId:number;
  isTeamMember:any;
  isRecipientUpdateAllowed: boolean;

  recipientVerificationStatus:string = "none";

  signingLinkRecipient: any = null;
  signingLinkUrl: string = '';
  signingLinkRetrievedRecipients: Set<number> = new Set();

  countryFlags:Array<{
    fileName:string,
    countryCode:string
    isoCode:string,
    phoneLength:number,
    countryName:string
  }> = require('../../assets/jsonFiles/countries/countries.json')

  currentCountryFlag:{
    fileName:string,
    countryCode:string // 90
    isoCode:string, // TR
    phoneLength:number,
    countryName:string
  };

  constructor(private http: HttpClient,
              private jobsApi:Communication.JobsService,
              private usersApi:Communication.UsersService,
              private emailsApi:Communication.EmailsService,
              private tagsApi:Communication.TagsService,
              private documentsApi:Communication.DocumentsService,
              private recipientApi:Communication.RecipientsService,
              private recipientRequestApi:Communication.RecipientRequestService,
              private accescodeApi:Communication.AccesscodeService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              public notificationService: NotificationService,
              public translate: TranslateService,
              private sftpApi: Communication.SftpService,
              private teamApi: Communication.TeamService) {

    this.afterLoadComplete = this.afterLoadComplete.bind(this);
  }


  ngOnInit() {
    $("body").css("overflow", "auto");
    if(!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    }else {

      this.InitializePopovers();
      this.InitModel();

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.subscriptions.push(this.toolbarService.eventOccured$.subscribe(
        (event: ToolbarEvent) => this.onToolbarEvent(event) //get the page info
      ));

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        (param) => {
          //convert string to number with +
          this.jobIDParameter = +param['id'];
          console.log("jobIDParameter:" + this.jobIDParameter);

          this.RoutingBack();
        })
      );

      let self = this;
      this.countryFlags.sort(function(a:any,b:any){
        let countryOne = self.translate.instant(a.countryName);
        let countryTwo = self.translate.instant(b.countryName);
        return countryOne.localeCompare(countryTwo)
      });

      this.onResize("");
      //this.initInputTagsScript();
      this.GetTheJob();
      this.GetTags();
    }
    this.subscriptions.push(
      this.teamApi.teamIsmemberPost(
        this.authorization.getAccessToken()
      ).subscribe(
        response => {
          this.isTeamMember = response;
        },
        error => {
          console.log(error);
          this.notificationService.displayError(error);
        }
      )
    )
  }

  @HostListener('window:resize', ['$event'])
  onResize($event:any) {
    if(this.stopResizeEvent) {
      return;
    }

    this.stopResizeEvent = true;

    let self = this;
    let previousZoom:number = this.zoom;
    let currentZoom:number = this.zoom;
    this.hasResize = true;

    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(function() {
      let width:number = $event != "" ? $event.target.innerWidth : $(window).width();

      if(width >= 1000) currentZoom = 1;
      if(width < 1000) currentZoom = 0.95;
      if(width < 950) currentZoom = 0.9;
      if(width < 900) currentZoom = 0.85;
      if(width < 850) currentZoom = 0.8;
      if(width < 800) currentZoom = 0.75;
      if(width < 750) currentZoom = 0.7;
      if(width < 700) currentZoom = 0.65;
      if(width < 650) currentZoom = 0.6;
      if(width < 600) currentZoom = 0.55;
      if(width < 550) currentZoom = 0.5;
      if(width < 500) currentZoom = 0.45;
      if(width < 450) currentZoom = 0.4;

      console.log("width: ",width + " zoom: ",previousZoom + "->"+ currentZoom);

      if(self.pdfLoading){
        console.log("---> PDF or SHAPE(s) LOADING <---");

        let timer:any = interval(500).subscribe(x => {

          if(!self.pdfLoading && self.previousWidth === undefined && currentZoom == 1){
            self.hasResize = false;
            self.previousWidth = width;
            if (timer != null)
              timer.unsubscribe();

          } else if (!self.pdfLoading && self.previousWidth != width) {
            console.log("Run resize AFTER......");
            self.doResize(previousZoom, currentZoom, width);

            if (timer != null)
              timer.unsubscribe();
          }
        });

      } else{
        console.log("Run resize DIRECT...");
        self.doResize(previousZoom, currentZoom, width);
      }

    }, 500);

  }

  doResize(previousZoom:number, currentZoom:number, width:number){
    this.hasResize = false;
    this.previousWidth = width;

    if(previousZoom == currentZoom) {
      //if (this.auditSignatures.length > 0) {
      this.pdfLoading = false;
      //}
    }
    else {
      this.zoom = currentZoom;
      console.log("zoom: ", this.zoom);
    }
  }

  private onToolbarEvent(event: ToolbarEvent)
  {
    this.currentToolbar = event;
  }

  /**
   * Whether this job's Signing Log can be downloaded by its owner.
   *
   * Derived from the job itself — see GetTheJob. Set from GET /jobs/{id} and from nowhere else:
   * job LIST rows share the same definition in agree.yaml, but the list is a native-query
   * projection that does not select `signature`, so a list row answers null for it and a gate
   * built on that would silently never open.
   */
  private signingLogAvailable: boolean = false;

  /**
   * The single way this page publishes a toolbar event.
   *
   * It exists so signingLogAvailable travels with every publish. The navbar assigns the event
   * wholesale (currentToolbar = event), so a publish that omits the flag does not leave the
   * Signing Log button alone — it removes it. This page publishes from seven places, several of
   * them ordinary actions like toggling the public link, so setting the flag only where the job
   * loads would give a button that appears and then vanishes when the user does something else.
   */
  private publishToolbar(event: ToolbarEvent) {
    event.signingLogAvailable = this.signingLogAvailable;
    this.toolbarService.action(event);
  }

  public GetTheJob(){
    this.subscriptions.push(this.jobsApi.jobsIdGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      (response:Communication.Job) => {

        // A Signing Log exists for a completed PAdES job and for nothing else. Both conditions are
        // load-bearing: COMPLETED alone would show the control on a completed CAdES job, which has
        // no log, so the download would fail. 'P' is the stored value for PAdES-LTA.
        this.signingLogAvailable =
          response.status === 'COMPLETED' && response.signature === 'P';

        if(response.status=="NONE" || response.status=="DRAFT") {
          this.isUserDataFetched = false;
          this.GetUser(); //refresh local storage
        } else if(response.status=="COMPLETED") {

          this.GetAuditSignature();
        }

        let timerSubscription = interval(500).subscribe(x => {
          if(this.isUserDataFetched)
          {
            if (timerSubscription != null)
              timerSubscription.unsubscribe();

            this.setJobSettings(response);

            //OWNER info
            this.jobOwner = response.user.name;
            //console.log("user  "+ response.user.name);
            let documentModel :Communication.Document = response.documents[0];
            let fileURL:string = Config.WEBSERVICEURL + '/documents/' + documentModel.id + '/download?variation=preview';
            let accessToken:string = this.authorization.getAccessToken();

            this.loadFile(fileURL, accessToken);
          }
        });

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        if (err.error && err.error.code == 214) {
          this.notificationService.notAuthorizedToAccessJob();
        } else {
          this.notificationService.displayError(err);
        }
      }
    ));
  }

  private loadFile(fileURL: string, accessToken: string): void {
    console.log('Loading PDF from:', fileURL);

    // Use fetch to get authenticated PDF and convert to blob URL
    this.loadPdfWithAuth(fileURL, accessToken).then((pdfBlob) => {
      if (pdfBlob) {
        const blobUrl = URL.createObjectURL(pdfBlob);
        this.pdfSrc.url = blobUrl;
        this.pdfSrc.httpHeaders = {}; // Clear headers as blob URL doesn't need them
        this.pdfLoading = false;
        console.log('PDF loaded successfully as blob URL');
      } else {
        console.error('Failed to load PDF');
        this.pdfLoading = false;
      }
    }).catch((error) => {
      console.error('Error loading PDF:', error);
      this.pdfLoading = false;
    });
  }

  private async loadPdfWithAuth(url: string, accessToken: string): Promise<Blob | null> {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'access_token': accessToken
        }
      });

      if (response.ok) {
        return await response.blob();
      } else {
        console.error('Failed to fetch PDF:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      return null;
    }
  }



  GetUser(){
    this.subscriptions.push(this.usersApi.usersGet(this.authorization.getAccessToken()).subscribe(
      (user:Communication.UserInfo) => {
        //console.log(user);
        this.isUserDataFetched=true;
        this.authorization.setUserAccount(user.subscription, this.authorization.userAccount.language);
      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  GetAuditSignature(){
    this.subscriptions.push(this.jobsApi.jobsIdAuditSignaturesGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      (response:Array<Communication.JobSignatureAudit>) => {

        for(let i=0; i< response.length; i++) {

          let positionJson:any = null;
          if(response[i].position) {
            let position: any = JSON.parse(response[i].position);

            positionJson = {
              x: position.x,
              y: position.y,
              width: position.width,
              height: position.height,
              page: position.page
            };

            if(!this.lastShapePage || this.lastShapePage < Number(position.page)) {
              this.lastShapePage = Number(position.page);
            }

          }

          let record:any = {
            recipientId: response[i].recipientId,
            name: response[i].name,
            image: response[i].image,
            position: positionJson
          };

          this.auditSignatures.push(record);
        }

        console.warn("AuditSignatures ",this.auditSignatures);

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  GetTags(){
    this.subscriptions.push(this.tagsApi.tagsGet(this.authorization.getAccessToken()).subscribe(
      (response:Communication.UserTagList) => {
        for(let tag of response.details)
          this.allTagItems.push(tag.name);

        this.refreshAvailableTags();
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  addToTag(tag:string){
    $('.tags-input').tagsinput('add', tag);
    this.refreshAvailableTags();
  }

  refreshAvailableTags(){
    this.availableTagItems = [];

    //available tag list user can add
    for(let tag of this.allTagItems)
      if(!this.tagItems.includes(tag))
        this.availableTagItems.push(tag);
  }

  filter(value:string){
    console.log("new value: " + value);
  }

  initInputTagsScript(){
    let _thisInput = this;

    $('.tags-input').tagsinput('removeAll');
    for(let i=0;i<this.theJob.tags.length;i++){
      this.addToTag(this.theJob.tags[i]);
    }

    $('input[type=email].tags-input').val(this.theJob.tags.toString());
    //console.log("tags initialized: " + JSON.stringify(this.theJob.tags));

    // Basic initialization
    $('.tags-input').tagsinput();

    $('.tags-input, .tagsinput-max-tags').on('change', function(event:any) {
      let $element = $(event.target);
      if (!$element.data('tagsinput')) return;

      _thisInput.tagItems = $element.tagsinput('items');
      //console.log("on change " + JSON.stringify($element.tagsinput('items')))

      //_thisInput.refreshAvailableTags();

    }).trigger('change');

    let allTags = this.availableTagItems;
    $(function () {

      // function from typeahead.js example
      let substringMatcher = function (strs:any) {
        return function findMatches(q:any, cb:any) {
          let matches:any;
          let substrRegex:any;

          // an array that will be populated with substring matches
          matches = [];

          // regex used to determine if a string contains the substring `q`
          substrRegex = new RegExp(q, 'i');

          // iterate through the pool of strings and for any string that
          // contains the substring `q`, add it to the `matches` array
          $.each(strs, function (i:any, str:any) {
            if (substrRegex.test(str)) {
              // the typeahead jQuery plugin expects suggestions to a
              // JavaScript object, refer to typeahead docs for more info
              matches.push({ value: str });
            }
          });

          cb(matches);
        };
      };

      let tags = $('input.tags-input');

      // initialize tagsinput for each tags-input classed input
      tags.tagsinput();

      $(tags).each(function (i:any, o:any) {
        // grab the input inside of tags-input
        let taginput = $(o).tagsinput('input');

        // ensure that a valid state is being entered
        /* $(o).on('itemAdded', function (event:any) {
           if (allTags.indexOf(event.item) < 0) {
             $(o).tagsinput('remove', event.item);
             //alert(event.item + " is not a valid state");
           }
         });*/

        // initialize typeahead for the tag input
        taginput.typeahead({
          hint: true,
          highlight: false,
          minLength: 0,
          //autoselect: true
        },{
          name: 'allTags',
          displayKey: 'value',
          limit: Infinity,
          source: substringMatcher(allTags)
        }).bind('typeahead:selected', $.proxy(function (obj:any, datum:any) {
          // if the state is clicked, add it to tagsinput and clear input
          $(o).tagsinput('add', datum.value);
          taginput.typeahead('val', '');
        }));
        // erase any entered text on blur
        $(taginput).blur(function () {
          // console.log($("input.tt-input").val());
          $(o).tagsinput('add', $("input.tt-input").val());
          taginput.typeahead('val', '');
        });

        /* $('.bootstrap-tagsinput').data('tagsinput').on('blur', 'input', function(event:any) {
             taginput.typeahead('val', '');
         });*/

      });

    });
  }

  setJobSettings(job:Communication.Job){
    let dumpJob = job;

    this.subscriptions.push(this.emailsApi.usersEmailsGet(this.authorization.getAccessToken()).subscribe(
      (response:Array<Communication.UserEmail>) => {

        let loginUserEmail = this.authorization.userProfile.email;
        this.jobLocation = dumpJob.location;

        for (let recipient of job.recipients) {
          for (let i=0; i<response.length; i++) {
            if (response[i].status == "ACTIVE" && response[i].email?.toLowerCase() == recipient.email?.toLowerCase()) {
              this.recipientState = recipient.status;

              if (loginUserEmail != job.user.email) {
                dumpJob.name = recipient.jobNameForRecipient;
                this.jobLocation = recipient.jobLocationForRecipient;  //job location for recipient
              }
            }
          }
        }

        this.theJob = dumpJob;
        this.jobNewName = this.theJob.name;
        this.isRecipientUpdateAllowed = this.theJob?.status == 'IN_PROGRESS' && (this.authorization.userProfile.email == this.theJob.user.email || this.isTeamMember != false);


        this.sharingDocument.id = this.theJob.id;
        this.sharingDocument.name = this.theJob.name;

        //set title
        this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, job.type, job.user.id, this.recipientState, job.name, job.status, this.jobLocation, "", ""));

        this.subscriptions.push(this.accescodeApi.accesscodesGet(this.authorization.getAccessToken(), String(this.theJob.id)).subscribe(
          response => {

            if(response.code != "") {

              let publicLink = Config.WEB_APP_URL + "/view/" + response.code;
              console.log("public link: " + publicLink);

              //set title
              this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, job.type, job.user.id, this.recipientState, job.name, job.status, this.jobLocation, publicLink, ""));
            }

          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
          }
        ));


        //this.setupJobOperations();
        //console.log("GetTheJob() -  status "+this.theJob.status);
        //console.log("GetTheJob() -  type "+this.theJob.type);
        console.log("job status get job" + this.theJob.status);
        // console.log("this.pdfSrc "+this.pdfSrc.url);
        console.log("this.theJob.documents[0].id " + this.theJob.documents[0].id);

        // If navigated here with the `#info` fragment (from the multi-sign page),
        // auto-open the job-details info modal — mirrors the toolbar JOB_DETAILS_INFO action.
        // Runs after theJob is loaded so showRecipientOrderList() has the recipient data.
        if(!this.infoFragmentHandled && this.activatedRoute.snapshot.fragment === 'info') {
          this.infoFragmentHandled = true;
          this.modalInfoVisibility = true;
          this.showRecipientOrderList();
          // The modal is a Bootstrap `modal fade` shown via the data API on the toolbar button;
          // the *ngIf only renders it — trigger the actual show after it's in the DOM.
          setTimeout(() => { $('#jobDetailsInfoModal').modal('show'); }, 300);
        }

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));

  }

  resendRequest(recipientId:number){
    this.subscriptions.push(this.recipientApi.recipientsIdResendrequestPut(this.authorization.getAccessToken(), recipientId).subscribe(
      response => {
        console.log("message was sent to recipient");
        this.notificationService.signingRequestResentToRecipient();
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  getSigningLink(recipient: any) {
    this.notificationService.showSigningLinkWarning(recipient.name, (isConfirmed: boolean) => {
      if (isConfirmed) {
        this.subscriptions.push(
          this.recipientRequestApi.recipientRequestsGet(
            this.authorization.getAccessToken(),
            String(recipient.id)
          ).subscribe(
            response => {
              this.signingLinkRecipient = recipient;
              this.signingLinkUrl = response.url;
              this.signingLinkRetrievedRecipients.add(recipient.id);
              $('#signingLinkModal').modal('show');
            },
            err => {
              console.log(err);
              this.notificationService.displayError(err);
            }
          )
        );
      }
    });
  }


  public RoutingBack() {
    //Bkz http://jasonwatmore.com/post/2016/12/08/angular-2-redirect-to-previous-url-after-login-with-auth-guard
    this.returnUrl = this.activatedRoute.snapshot.queryParams['url'] || '';
    console.log("this.returnUrl " + this.returnUrl);
  }

  public downloadDocument(id:number, name:string, variation: 'original' | 'signed') {
    let reader = new FileReader();
    this.notificationService.documentDownloadStarted(name);

    // Determine MIME type based on signature type
    // CAdES can sign any file type, so use octet-stream for both original and signed
    // PAdES is always PDF
    const isCAdES = this.theJob.signature === 'C_ENV' || this.theJob.signature === 'C_DET';
    const mimeType = isCAdES ? 'application/octet-stream' : 'application/pdf';

    this.subscriptions.push(this.documentsApi.documentsIdDownloadGet(this.authorization.getAccessToken(), id, variation).subscribe(
      (data:any) => {
        // If data is a Blob or ArrayBuffer
        let blob: Blob;
        if (data instanceof Blob) {
          blob = data;
        } else if (data instanceof ArrayBuffer) {
          blob = new Blob([data], { type: mimeType });
        } else if (data && data.body) {
          blob = new Blob([data.body], { type: mimeType });
        } else {
          console.error('Unknown data format for download');
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.documentNotFound();
      }
    ));
    reader.onloadend = function (e) {
      window.open(reader.result.toString(), "_blank");
    }
  }



  public StartRequestSignature(){
    this.subscriptions.push(this.jobsApi.jobsIdActionsStartrequestsignaturePut(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      response => {
        console.log("Startrequest - status: " + response.status +", type: "+response.type);
        this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, response.type, response.user.id, this.recipientState, response.name, response.status, this.jobLocation, "", ""));
        this.navigateToRequest();
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  public Startself(){
    this.subscriptions.push(this.jobsApi.jobsIdActionsStartselfPut(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      response => {
        console.log("Startself - status: " + response.status + ", type: " + response.type);
        this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, response.type, response.user.id, this.recipientState, response.name, response.status, this.jobLocation, "", ""));
        this.navigateToSelf();
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  public RequestCode(){
    console.log("RequestCode()");
    this.subscriptions.push(this.recipientRequestApi.recipientRequestsJobIdGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      response => {
        this.requestCode=response.code;
        console.log("requestCode "+ this.requestCode);

        //self sign ya da request biçimiyle...
        this.navigateToSign();

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  public navigateToRequest() {
    console.log("this.theJob.id " + this.theJob.id);
    this.router.navigate(["/prepare", this.theJob.id])

  }

  public navigateToSelf() {
    console.log("this.theJob.id " + this.theJob.id);
    this.router.navigate(["/prepare-self", this.theJob.id])

  }


  public navigateToSign() {
    console.log("navigateToSign - signature type: " + this.theJob.signature);

    // Route based on signature type
    if (this.theJob.signature === 'C_ENV' || this.theJob.signature === 'C_DET') {
      // CAdES signing (container)
      this.router.navigate(["/signc", this.requestCode]);
    } else {
      // PAdES signing (PDF) - default
      this.router.navigate(["/sign", this.requestCode]);
    }
  }

  public navigateToCombine() {
    console.log("navigateToSign");
    this.router.navigate(["/combine", this.jobIDParameter]);
  }


  incrementPage(amount:number) {
    this.page += amount;
  }

  incrementZoom(amount:number) {
    if(this.pdfLoading) {
      console.log("---> PDF or SHAPE(s) LOADING <---");
    } else {
      let newZoom = this.zoom + amount >= 0.2 ? this.zoom + amount : 0.2;

      if(this.zoom != newZoom) {
        this.zoom = newZoom;
      }
    }
  }

  /**
   * Get pdf information after it's loaded
   * @param event - Event from ngx-extended-pdf-viewer
   */
  afterLoadComplete(event: any) {
    // ngx-extended-pdf-viewer provides different event structure
    this.pdf = event.source || event;
    const numPages = event.pagesCount || event.numPages || (this.pdf && this.pdf.numPages);

    this.pdfLoading = true;
    console.warn("DÖKÜMAN YÜKLENIYOR. Toplam " + numPages + " sayfa");

    this.pdfLoading = false;

    // Force a resize/redraw to fix initial sizing issues
    // This ensures the PDF viewer properly fills its container
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);

  }


  onError($event:any){
    //console.error($event)
    //this.notificationService.documentNotFound();
  }

  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "ROTATE":
        //this.rotate(Number(event.value));
        break;
      case "INCREMENT_ZOOM":
        this.incrementZoom(Number(event.value));
        break;
      case "JOB_DETAILS_INFO": {
        this.modalInfoVisibility = true;
        this.showRecipientOrderList();
        break;
      }
      case "OPEN_ATTACHMENTS": {
        this.attachmentsModalVisibility = true;
        setTimeout(() => { $('#attachmentsModal').modal('show'); }, 100);
        break;
      }
      case "JOB_DETAILS_TAG":
        this.initInputTagsScript();
        break;
      case "JOB_DETAILS_ACTIVITY_HISTORY":
        this.getJobHistory();
        break;
      case "VALIDATE_DOCUMENT":
        this.validationModalVisible = true;
        this.validationResult = null;
        this.validationLoading = false;
        this.validationError = null;
        break;
      case "REQUEST_SIGN":
      {
        if(this.theJob.status=="NONE")
          this.StartRequestSignature(); //NONE TO DRAFT
        else if(this.theJob.status=="DRAFT")
          this.navigateToRequest();  // DRAFT TO IN_PREGRESS
        else if(this.theJob.status=="IN_PROGRESS")
          this.RequestCode();  // get the request code and go to sign
        break;
      }
      case "SELF_SIGN":
      {
        if(this.theJob.status=="NONE")
          this.Startself(); //NONE TO DRAFT
        else if(this.theJob.status=="DRAFT")
          this.navigateToSelf();  // DRAFT TO IN_PREGRESS //this.Finish(); // DRAFT TO IN_PREGRESS
        else if(this.theJob.status=="IN_PROGRESS")
          this.RequestCode();  // get the request code and go to sign
        break;
      }
      case "DOWNLOAD_ORJ":
        this.DownloadOriginal();
        break;
      case "DOWNLOAD_SIGNED":
        this.DownloadSigned();
        break;
      case "DOWNLOAD_SIGNING_LOG":
        this.DownloadSigningLog();
        break;
      case "SET_JOB_LOCATION":
        this.setJobLocation(event.value);
        break;
      case "DELETE_DOC":
        this.DeleteJob();
        break;
      case "COMBINE_DOC":
        this.navigateToCombine();
        break;
      case "SHARE_SIGNED_DOC":
        this.sharingModalVisibility = true;
        break;
      case "GET_PUBLIC_LINK":
        this.getPublicLink();
        break;
      case "STOP_SHARING_PUBLIC":
        this.stopPublicSharing();
        break;
      case "CREATE_TEMPLATE": {
        // Use a regular expression to match emails starting with 'info' at the 'imzayeri.com' domain.
        const isAdmin = /^info.*@imzayeri\.com$/.test(this.authorization.userProfile.email);

        if(isAdmin) {
          $('#createTemplate').modal('show');
        } else {
          this.createTemplate();
        }
      }
        break;
      case "APPLY_TEMPLATE":
        this.applyTemplate();
        break;
      case "SFTP_LIST":
        this.initSftpList();
        break;
    }
  }


  public createTemplate(){
    let category:string = this.template.category || "default";

    this.subscriptions.push(this.jobsApi.templateJobIdPost(this.authorization.getAccessToken(), this.theJob.id, category, this.template.definition).subscribe(
      (response:any) => {
        console.log("Şablon oluşturuldu.");
        $('#createTemplate').modal('hide');
        this.template={};

        this.notificationService.templateCreated();
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        $('#createTemplate').modal('hide');
        this.notificationService.displayError(err);
      }
    ));
  }

  applyTemplate(){
    this.getTemplates();
  }

  getTemplates(){
    this.templateVisibility=true;

    this.subscriptions.push(this.jobsApi.templatesJobsGet(this.authorization.getAccessToken()).subscribe(
      (response:Communication.JoblistResult) => {
        this.templateJobs = response.jobs;
      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }));
  }

  chooseTemplate(templateId:number){
    // Store the selected template for later use
    this.selectedTemplate = this.templateJobs.find(template => template.id === templateId);

    this.subscriptions.push(this.jobsApi.jobsIdTemplateTemplateIdPut(this.authorization.getAccessToken(), this.theJob.id, templateId).subscribe(
      (response: Communication.Job) => {
        $('#jobTemplate').modal('hide');
        this.theJob = response;

        if(this.theJob.type.toUpperCase() == 'SELF')
          this.navigateToSelf();
        else
          this.navigateToRequest();

        //set current status
        this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, response.type, response.user.id, "INLINE", response.name, response.status, response.location, "", ""));
        this.notificationService.templateApplied();
        console.log("template applied....")
      }, //Bind to view
      err  => {
        // Log errors if any
        console.log(err);
        if (err instanceof HttpErrorResponse) {
          let errorJson = err.error;
          if(errorJson.code == 276) { //incompatible api Version
            $('#jobTemplate').modal('hide');
            this.notificationService.showTemplateVersionConflict((isConfirmed: boolean) => {
              if (isConfirmed) {
                // Navigate to template editor based on template type
                if (this.selectedTemplate.type === 'SELF') {
                  this.router.navigate(['/template-self', this.selectedTemplate.id]);
                } else {
                  this.router.navigate(['/template', this.selectedTemplate.id]);
                }
              }
            });
            return;
          }
        }
        this.notificationService.displayError(err);
      }));
  }

  getPublicLink() {

    if (this.currentToolbar.sharePublicLink == "") {

      this.subscriptions.push(this.accescodeApi.accesscodesPost(this.authorization.getAccessToken(), String(this.theJob.id)).subscribe(
        response => {
          let publicLink = Config.WEB_APP_URL + "/view/" + response.code;
          console.log("public link: " + publicLink);

          //set current status
          this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, this.currentToolbar.type, this.currentToolbar.jobOwnerId, this.recipientState, this.currentToolbar.title, this.currentToolbar.value, this.jobLocation, publicLink, ""));

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
          $("#publicLink").modal('hide'); //hide add modal
        }
      ));

    }
  }

  stopPublicSharing() {

    if(this.currentToolbar.sharePublicLink != "") {

      let parts = this.currentToolbar.sharePublicLink.split('/');
      let publicLinkCode = parts[parts.length - 1];

      this.subscriptions.push(this.accescodeApi.accesscodesCodeDelete(this.authorization.getAccessToken(), publicLinkCode).subscribe(
        response => {

          console.log("public link removed...");
          this.notificationService.publicLinSharingStopped();

          //set current status
          this.publishToolbar(new ToolbarEvent(ToolbarEventPageEnum.JOB_DETAILS, this.currentToolbar.type, this.currentToolbar.jobOwnerId, this.recipientState, this.currentToolbar.title, this.currentToolbar.value, this.jobLocation, "", ""));

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
        }
      ));

    }
  }

  showRecipientOrderList(){

    this.containers = [];
    let maxOrderNo = 1;

    for (let recipient of this.theJob.recipients) {
      if(Number(recipient.orderno) > maxOrderNo) {
        maxOrderNo = Number(recipient.orderno);
      }
    }

    for (let i=1; i<=maxOrderNo; i++) {
      let orderGroup:Array<Communication.Recipient> = [];

      for (let recipient of this.theJob.recipients) {
        if(Number(recipient.orderno) == i)
          orderGroup.push(recipient);
      }

      //if(orderGroup.length > 0) {
      //console.log("orderGroup: "+ i +". - lenght: "+ orderGroup.length)
      this.containers.push(new Container(orderGroup));
      //}
    }
  }

  public getJobHistory(){

    this.subscriptions.push(this.jobsApi.jobsIdHistoryGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      response => {
        this.theJobHistory = response;

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  public validateDocument(){
    this.validationLoading = true;
    this.validationError = null;
    this.validationResult = null;

    const documentId = this.theJob?.documents?.[0]?.id;
    if (!documentId) {
      this.validationError = this.translate.instant('NO_DOCUMENT_FOUND');
      this.validationLoading = false;
      return;
    }

    this.subscriptions.push(
      this.documentsApi.documentsIdValidateGet(
        this.authorization.getAccessToken(),
        documentId
      ).subscribe(
        response => {
          this.validationResult = response;
          this.validationLoading = false;
        },
        err => {
          console.log(err);
          this.validationError = err.error?.message || this.translate.instant('VALIDATION_FAILED');
          this.validationLoading = false;
          this.notificationService.displayError(err);
        }
      )
    );
  }

  // Validation modal helper methods
  toggleValidationPanel(panelId: string): void {
    this.expandedPanels[panelId] = !this.expandedPanels[panelId];
  }

  getValidationHeaderClass(): string {
    if (!this.validationResult) return 'bg-primary';
    switch (this.validationResult.resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'bg-success';
      case 'INVALID': return 'bg-danger';
      case 'CONTAINS_INVALID': return 'bg-warning';
      default: return 'bg-primary';
    }
  }

  getValidationIcon(): string {
    if (!this.validationResult) return 'icon-file-check';
    switch (this.validationResult.resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'icon-checkmark-circle';
      case 'INVALID': return 'icon-cross-circle';
      case 'CONTAINS_INVALID': return 'icon-warning';
      default: return 'icon-file-check';
    }
  }

  getResultIcon(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'icon-checkmark-circle text-success';
      case 'INVALID': return 'icon-cross-circle text-danger';
      case 'CONTAINS_INVALID': return 'icon-warning text-warning';
      case 'CANT_CHECK': return 'icon-question3 text-muted';
      case 'NOT_REVOKED': return 'icon-checkmark text-success';
      default: return 'icon-info3 text-muted';
    }
  }

  getResultLabelClass(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'label-success';
      case 'INVALID': return 'label-danger';
      case 'CONTAINS_INVALID': return 'label-warning';
      default: return 'label-default';
    }
  }

  getResultAlertClass(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'alert-success';
      case 'INVALID': return 'alert-danger';
      case 'CONTAINS_INVALID': return 'alert-warning';
      default: return 'alert-info';
    }
  }

  getResultTextClass(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'text-success';
      case 'INVALID': return 'text-danger';
      case 'CONTAINS_INVALID': return 'text-warning';
      default: return '';
    }
  }

  getSignaturePanelClass(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return 'panel-success';
      case 'INVALID': return 'panel-danger';
      case 'CONTAINS_INVALID': return 'panel-warning';
      default: return 'panel-default';
    }
  }

  getRevocationLabelClass(resultType: string): string {
    switch (resultType) {
      case 'NOT_REVOKED': return 'label-success';
      case 'REVOKED': return 'label-danger';
      case 'CANT_CHECK': return 'label-warning';
      default: return 'label-default';
    }
  }

  getResultText(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return this.translate.instant('All signatures are valid');
      case 'INVALID': return this.translate.instant('Document validation failed');
      case 'CONTAINS_INVALID': return this.translate.instant('Some signatures are invalid');
      default: return this.translate.instant('Unknown status');
    }
  }

  getResultTypeText(resultType: string): string {
    switch (resultType) {
      case 'VALID':
      case 'ALL_VALID': return this.translate.instant('RESULT_VALID');
      case 'INVALID': return this.translate.instant('RESULT_INVALID');
      case 'CONTAINS_INVALID': return this.translate.instant('RESULT_CONTAINS_INVALID');
      default: return resultType;
    }
  }

  extractCN(dn: string): string {
    if (!dn) return '';
    const cnMatch = dn.match(/CN=([^,]+)/);
    return cnMatch ? cnMatch[1] : dn;
  }

  getAuditLogInfo(info:string):any{
    if(info.indexOf("SIGNING DOC. HASH") > -1 || info.indexOf("RECEIVED SIGNATURE") > -1) {
      return info.split(",")[0];
    } else {
      return info;
    }
  }


  showHistoryDetails(auditLog:Communication.AuditLog){
    this.selectedAuditLog = auditLog;
    this.selectedAuditLogDetail = [];

    if(auditLog.info.indexOf("SIGNING DOC. HASH") > -1 || auditLog.info.indexOf("RECEIVED SIGNATURE") > -1) {
      let infoDetail:string = auditLog.info.split(",")[1];

      this.selectedAuditLogDetail[0] = this.translate.instant(infoDetail.split(":")[0].trim());
      this.selectedAuditLogDetail[1] = infoDetail.split(":")[1];
      console.log("selectedAuditLogDetail: ", this.selectedAuditLogDetail)
    }
  }


  updateLabels(field:string){
    let tags = field == "tags" ? this.tagItems.toString() :  this.theJob.tags.toString();

    this.subscriptions.push(this.jobsApi.jobsIdPut(this.authorization.getAccessToken(), this.theJob.id, tags, this.jobNewName).subscribe(
      (response:Communication.Job) => {
        console.log("tags and name updated... ");
        this.setJobSettings(response);

      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  /**
   * Download the Signing Log for this job, as its owner.
   *
   * GET /jobs/{id}/signinglog, not the access-code endpoint the guest page uses: the owner has no
   * access code. Authorisation is entirely server-side — the endpoint re-checks ownership and the
   * same completed/PAdES rule the rendered control is gated on, so showing the control is the
   * second of two agreeing checks rather than the only one.
   *
   * Built by hand rather than through the generated client because the path is not declared in the
   * pinned API specification. It moves to the typed client when that pointer moves; a hand-built
   * call left behind after the specification catches up is how a call silently stops matching it.
   */
  public DownloadSigningLog() {
    const name = (this.theJob?.name || 'document') + ' - Signing Log.pdf';
    this.notificationService.documentDownloadStarted(name);

    const url = Config.WEBSERVICEURL + '/jobs/' + encodeURIComponent(String(this.theJob.id)) + '/signinglog';
    const headers = new HttpHeaders({ access_token: this.authorization.getAccessToken() });

    this.subscriptions.push(this.http.get(url, { headers: headers, responseType: 'blob' }).subscribe(
      (data: Blob) => {
        if (data.type === 'application/json') {
          // Refusals arrive as a JSON body with a 200, the shape the document download already
          // handles. The owner's flag does not expire, but the server is still free to refuse and
          // the page must say so rather than hand the user a PDF-named blob of JSON.
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              this.notificationService.displayError(errorJson.description || errorJson.message);
            } catch (e) {
              this.notificationService.documentNotFound();
            }
          };
          reader.readAsText(data);
          return;
        }

        const blobUrl = window.URL.createObjectURL(data);
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', blobUrl);
        linkElement.setAttribute('download', name);
        linkElement.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: false }));
        window.URL.revokeObjectURL(blobUrl);
      },
      (err) => {
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  public DownloadSigned() {
    console.log("Download Signed");
    const extension = this.getDocumentExtension(false);
    this.downloadDocument(this.theJob.documents[0].id, this.jobNewName + extension, 'signed');
  }


  public DownloadOriginal() {
    console.log("Download Original");
    const extension = this.getDocumentExtension(true);
    this.downloadDocument(this.theJob.documents[0].id, this.jobNewName + extension, 'original');
  }

  /**
   * Get file extension based on signature type
   * @param isOriginal - true for original document, false for signed
   */
  private getDocumentExtension(isOriginal: boolean): string {
    const isCAdES = this.theJob.signature === 'C_ENV' || this.theJob.signature === 'C_DET';

    if (isOriginal) {
      if (isCAdES) {
        // CAdES can sign any file type - extract extension from original document name
        const docName = this.theJob.documents[0]?.name || '';
        const lastDot = docName.lastIndexOf('.');
        return lastDot > 0 ? docName.substring(lastDot) : '';
      }
      // PAdES original is always PDF
      return '.pdf';
    }

    // For signed documents
    if (isCAdES) {
      // CAdES signed documents are binary containers
      return '.p7s';
    }

    // PAdES (default) - PDF with embedded signature
    return '.pdf';
  }

  public setJobLocation(location: string){
    if(location == "INBOX")
      this.moveToInbox(this.theJob.id);
    else
      this.moveToArchive(this.theJob.id);
  }


//<--- DELETE JOB --->
//Not: bazı durumlarda theJob.id kullanmak hataya yok açıyor
  public DeleteJob() {
    console.log("Delete job: " + this.jobIDParameter);

    let _thisJob = this;
    this.notificationService.showJobDeleteAlert("job", function(isConfirmed:boolean) {
      if(isConfirmed)
        _thisJob.Delete();
    });
  }


  public Delete() {
    let jobName = this.theJob.name;
    let _thisDelete=this;

    /*setTimeout(function(){ //silme işlemi sonrası  alert tetiklenmediği için 1 sn gecikme ekledik*/
    _thisDelete.subscriptions.push(_thisDelete.jobsApi.jobsIdDelete(_thisDelete.authorization.getAccessToken(), _thisDelete.jobIDParameter).subscribe(
      (response:any) => {
        if (response.code == 200) {
          _thisDelete.notificationService.jobDeleted(jobName);
          _thisDelete.router.navigate(['docs']);
        }
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
    // }, 1000);
  }

  //<--- DELETE JOB --->

  moveToArchive(jobId:number){
    this.subscriptions.push(this.jobsApi.jobsIdMovetoarchivePut(this.authorization.getAccessToken(), jobId).subscribe(
      (response:Communication.Job) => {
        this.setJobSettings(response);
        console.log(response.location);
        this.notificationService.jobMovedToArchive(response.name);
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  moveToInbox(jobId:number){
    this.subscriptions.push(this.jobsApi.jobsIdMovetoinboxPut(this.authorization.getAccessToken(), jobId).subscribe(
      (response:Communication.Job) => {
        this.setJobSettings(response);
        console.log(response.location);
        this.notificationService.jobMovedToInbox(response.name);
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  public RedirectReferredPage() {
    console.log("RedirectReferredPage");
    if (this.returnUrl != '') {
      //this.router.navigate([this.returnUrl]);
      window.location.href = this.returnUrl;
      console.log("this.returnUrl != '' this.returnUrl " + this.returnUrl);
    } else
      this.location.back(); // çağıran sayfaya dönmek için
  }

  showRecipent(recipient:Communication.Recipient) {

    if (this.authorization.userAccount.subscription.plan.modifyRecipient == 'Y'){

      this.theRecipient.id = recipient.id;
      this.theRecipient.name = recipient.name;
      this.theRecipient.email = recipient.email;
      this.theRecipient.citizenId = recipient.citizenId;
      this.theRecipient.role = recipient.role;
      this.theRecipient.workflowEffect = recipient.workflowEffect;
      this.theRecipient.smsRequired = recipient.smsRequired;
      this.theRecipient.smsCountryCode = recipient.smsCountryCode;

      this.countryFlags.forEach(element => {
        if(this.theRecipient.smsCountryCode == element.countryCode){
          this.pickCountry(element);
        }
      });

      if(this.theRecipient.smsRequired == null){
        this.recipientVerificationStatus = "none"
      } else {
        if(this.theRecipient.smsRequired.length >= 4){
          this.recipientVerificationStatus = "mobile"
        } else if (this.theRecipient.citizenId.length == 11){
          this.recipientVerificationStatus = "identity"
        } else {
          this.recipientVerificationStatus = "none"
        }
      }

      console.log(this.theRecipient)

      //if user is recipient, cant change his own email
      if (recipient.email?.toLowerCase() == this.theJob.user.email?.toLowerCase())
        this.isDisabled = true;
      else this.isDisabled = false;

      $("#updateDetailRecipient").modal('show'); //open edit modal

    } else {
      this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) {
        if (isConfirmed) {
        }
      })
    }

  }

  public updateRecipient(formData: Communication.Recipient) {
    let self = this;
    this.notificationService.showRecipientInfoChangedAlert(function (isConfirmed: boolean) {
      if (isConfirmed) {

        $("#updateDetailRecipient").modal('hide'); //hide edit modal
        console.log("theRecipient " + formData.email);
        formData.email = formData.email?.toLowerCase();
        let updatedRecipient = { id:formData.id, name: formData.name, email: formData.email, citizenId:formData.citizenId , smsRequired: formData.smsRequired, smsCountryCode: formData.smsCountryCode};

        self.subscriptions.push(
        self.recipientApi.recipientsIdPut(
          self.authorization.getAccessToken(),
          formData.id,
          formData.name,
          formData.email,
          formData.citizenId,
          formData.role,
          formData.workflowEffect,
          formData.smsRequired,
          formData.smsCountryCode,
        ).subscribe(
          (response: Communication.ResponseMessage) => {
            console.log("recipient updated...");

            let dumpJob = self.theJob;
            for (let i = 0; i < dumpJob.recipients.length; i++) {
              if (dumpJob.recipients[i].id == updatedRecipient.id) {
                dumpJob.recipients[i].email = updatedRecipient.email;
                dumpJob.recipients[i].name = updatedRecipient.name;
                dumpJob.recipients[i].citizenId = updatedRecipient.citizenId;
                dumpJob.recipients[i].smsRequired = updatedRecipient.smsRequired;
                dumpJob.recipients[i].smsCountryCode = updatedRecipient.smsCountryCode;

                self.countryFlags.forEach(element => {
                  if (self.theRecipient.smsCountryCode == element.countryCode) {
                    self.pickCountry(element);
                  }
                });

                self.theJob = dumpJob;
                self.showRecipientOrderList();
                break;
              }
            }
            self.notificationService.recipientUpdated();
          }, // Bind to view
          err => {
            console.log(err);
            let errorObject = JSON.parse(err._body);
            if (errorObject.code == 265) {
              this.notificationService.smsQuotaIsFull();
            } else {
              this.notificationService.displayError(err);
            }
          }
        ));

      }

    })
  }

  // initialize model here
  InitModel(){
    this.theRecipient = {
      id: 0,
      jobLocationForRecipient: "",
      jobNameForRecipient: "",
      orderno: "",
      share: 0,
      smsSent: "",
      status: "",
      sufficientshare: 0,
      updated: 0,
      name: '',
      email: '',
      citizenId: '',
      role:'SIGNER', //VIEWER, COPY
      workflowEffect:'OWNER', //OPTIONAL, REQUIRED
      smsRequired: '',
      smsCountryCode: Config.PHONE_CODE_NUMBER.toString()
    }
    this.countryFlags.forEach(element => {
      if(element.countryCode == Config.PHONE_CODE_NUMBER.toString()){
        this.pickCountry(element);
      }
    });
  }

  // Floating Labels
  getClasses(input:string):any{
    if(input && input.trim().length > 0) return "is-visible";
    else return "animate";
  }

  getNameClasses(recipient:Communication.Recipient):string{
    if(this.authorization.userProfile.email == this.theJob.user.email || this.isTeamMember != false )
    {
      let item:number = 0;
      if(recipient.status == 'WAITING'){
        item = 1;
      }

      if(this.theJob.status == "DRAFT"){
        return 'col-md-10 col-sm-10 col-xs-9';
      }

      if(this.theJob.status == 'IN_PROGRESS' && (recipient.status == 'WAITING' || recipient.status == 'INLINE')){
        item = (item==0) ? 2 : 3;
      }

      return item==0 ? 'col-md-10 col-sm-10 col-xs-9' : item==1 ? 'col-md-8 col-sm-6 col-xs-5' : item==2 ? 'col-md-8 col-sm-8 col-xs-7' : 'col-md-6 col-sm-4 col-xs-3';
    }
    else {
      return 'col-md-10 col-sm-10 col-xs-9';
    }
  }

  checkSufficientShareValidity(recipientContainer:Container){
    if(recipientContainer.widgets.length == 0){
      return false;
    }
    if(recipientContainer.widgets[0].sufficientshare == null){
      return false;
    }
    return true;
  }

  getGroupSufficientShare(id:number){
    if(this.containers[id].widgets.length == 0) return "-";
    if(this.containers[id].widgets[0].sufficientshare == null)
      return "-";
    return this.containers[id].widgets[0].sufficientshare;
  }

  assignGroupNumberStyle(id:number){

    if(this.containers[id].widgets.length == 0) return "label label-default";
    if(this.theJob.status == "DRAFT") return "label label-default";

    let i;
    let currentShare = 0;
    let sufficientShare = this.containers[id].widgets[0].sufficientshare;

    if(sufficientShare == null){
      for(i=0;i<this.containers[id].widgets.length;i++){
        if(this.containers[id].widgets[i].status != "SIGNED"){
          return "label label-danger";
        }
        return "label label-success";
      }
    }

    for(i=0;i<this.containers[id].widgets.length;i++){
      if(this.containers[id].widgets[i].status == "INLINE"){
        return "label label-danger";
      }
      if(this.containers[id].widgets[i].status == "SIGNED"){
        currentShare += this.containers[id].widgets[i].share;
      }
    }

    if(currentShare >= sufficientShare){
      return "label label-success";
    }
    return "label label-danger";
  }

  InitializePopovers()
  {
    $('#name').popover({
      title: this.translate.instant('Name'),
      content: this.translate.instant('Name as exactly on Citizen Card.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

    $('#email').popover({
      title: this.translate.instant('Email'),
      content: this.translate.instant('Email address that you want to send the request.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

    $('#citizenId').popover({
      title: this.translate.instant('citizenId'),
      content: this.translate.instant('Citizen ID will be checked on the signature if you fill the information.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });

    $('#smsRequired').popover({
      title: this.translate.instant('Phone Number'),
      content: this.translate.instant('Phone number will be used for SMS Verification.'),
      placement: 'right',
      trigger: 'focus',
      template: '<div class="popover bg-default" style="min-width:200px; max-height:200px;"><div class="arrow"></div><div class="popover-content"></div></div>'
    });
  }

  TimeDiff(time_ms:any):string {
    let difference = new Date().getTime() - time_ms;

    if (difference < 0) {
      difference = 0;
    }

    difference = difference / 1000; // for milli seconds
    var seconds = Math.floor(difference % 60);
    difference = difference / 60;
    var minutes = Math.floor(difference % 60);
    difference = difference / 60;
    var hours = Math.floor(difference % 24);
    difference = difference / 24;
    var days = Math.floor(difference % 30);
    var mounts = Math.floor((difference % 364 ) / 30);
    var years = Math.floor(difference / 364);

    let diff:string = "";

    if (years > 0) diff += years + " yıl ";
    if (mounts > 0) diff += mounts + " ay ";
    if (days > 0) diff += days + " gün ";
    if (hours > 0) diff += hours + " sa ";
    if (minutes > 0) diff += minutes + " dk ";

    return diff;
  }

  initSftpList(){
    this.subscriptions.push(
      this.sftpApi.sftpListGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {
          this.sftpDetails = [];
          for(let i=0;i<response.length;i++){
            this.sftpDetails.push({
              serverName:response[i].serverName,
              id:response[i].id

            });
          }
          console.log(this.sftpDetails);
        },
        err => {
          console.log(err);
        }
      )
    )
  }

  send2Sftp(){
    this.subscriptions.push(
      this.sftpApi.sftpSendPost(
        this.authorization.getAccessToken(),
        this.checkedSftpServer,
        this.jobIDParameter.toString()
      ).subscribe(
        response => {
          console.log(response);
          this.notificationService.sftpFileSentSuccess();
          $('#sftpList').modal('hide');
        },
        err => {
          console.log(err);
          this.notificationService.sftpFileSentError();
          $('#sftpList').modal('hide');
        }
      )
    )
  }

  checkRadioButton(id:number){
    for(let i=0;i<this.sftpDetails.length;i++){
      $('#sftpListDiv_'+this.sftpDetails[i].id).css('background-color', 'white');
    }
    $('#sftpRadioButton_'+id).prop("checked", true);
    $('#sftpListDiv_'+id).css('background-color', '#d8f3dc');
    this.checkedSftpServer = id.toString();
  }

  showChangeDepartment(){
    this.subscriptions.push(
      this.teamApi.teamGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {
          this.ownerTeamMembers = [];
          for(let i=0;i<response.length;i++){
            this.ownerTeamMembers.push({
              id: response[i].id,
              branch: response[i].branch,
              memberEmail: response[i].member.email
            });
            let data:any = this.theJob;
            if(data.teamMember != null){
              this.currentDepartmentId = data.teamMember.id;
            }
          }
        },
        (error) => {
          this.notificationService.displayError(error);
          console.log(error);
        }
      )
    )
  }

  changeDepartment(){
    this.subscriptions.push(
      this.teamApi.teamDepartmentPost(
        this.authorization.getAccessToken(),
        this.theJob.id.toString(),
        $('#departmentDropdown').val()
      ).subscribe(
        (response:any) => {
          $("#changeDepartmentModal").modal("hide");
          this.GetTheJob();
          this.notificationService.departmentUpdated();
          console.log(response);
        },
        (error:any) => {
          this.notificationService.displayError(error);
          console.log(error);
        }
      )
    )
  }

  changeDepartmentVisibility(){
    let currentJob:any = this.theJob;
    if(currentJob.status == "DRAFT" && currentJob.type == "ME_OTHERS"){
      return false;
    } else if(this.theJob.status == "DRAFT" && currentJob.type == "SELF"){
      if(currentJob.teamMember == null){
        return false;
      } else {
        return true;
      }
    } else if(currentJob.status == "NONE" || currentJob.status == "COMPLETED" || currentJob.status == "IN_PROGRESS"){
      return true;
    } else {
      return false;
    }
  }

  checkVerificationRadioButton(type:string){
    this.recipientVerificationStatus = type;
    $('#'+type+'RadioButton').prop("checked", true);

    if(this.recipientVerificationStatus == "none"){
      this.theRecipient.citizenId = "";
      this.theRecipient.smsRequired = "";
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
    } else if (this.recipientVerificationStatus == "mobile") {
      this.theRecipient.citizenId = "";
    } else if (this.recipientVerificationStatus == "identity"){
      this.theRecipient.smsRequired = "";
      this.theRecipient.smsCountryCode = Config.PHONE_CODE_NUMBER.toString();
    }
  }

  calculatePhoneNumberLength(data:{fileName:string,countryCode:string,isoCode:string,phoneLength:number,countryName:string}){
    let phoneLength;
    this.countryFlags.forEach(element => {
      if(element.countryCode == data.countryCode){
        phoneLength = element.phoneLength;
      }
    });
    return phoneLength;
  }

  pickCountry(data:{fileName:string,countryCode:string,isoCode:string,phoneLength:number,countryName:string}){
    this.currentCountryFlag = data;
    this.theRecipient.smsCountryCode = data.countryCode;
  }

  /**
   * Check if the job's API version doesn't match the current API version
   * Used to display warning for templates with old coordinate system
   */
  isApiVersionMismatch(job: Communication.Job): boolean {
    return job.apiVersion != null && job.apiVersion !== Config.API_VERSION;
  }

  onAttachmentsClosed(): void {
    this.attachmentsModalVisibility = false;
  }

  ngOnDestroy() {
    $('.modal-backdrop').remove();

    // Clean up blob URLs to prevent memory leaks
    if (this.pdfSrc.url && this.pdfSrc.url.startsWith('blob:')) {
      URL.revokeObjectURL(this.pdfSrc.url);
    }

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }

}
declare var swal:any;


declare var tagsinput:any;

class Container {
  constructor(public widgets: Array<Communication.Recipient>) {}
}
